import type { MapTheme, Tile } from "@dailywars/core/engine";
import {
  DROP_ZONE_OVERLAY_LAYER_NAMES,
  resolveDropZoneOverlayLayerNames,
  type DropZoneOverlayLayerName,
} from "@dailywars/core/render/dropZoneOverlays";
import { DEFAULT_MAP_THEME } from "@dailywars/core/render/mapThemes";

import { loadCachedImage } from "#/game/cachedImage";

function dropZoneLayerUrl({ theme, layerName }: { theme: MapTheme; layerName: string }): string {
  return `/terrain/${theme}/dropZone/${layerName}`;
}

function getDropZoneOverlayImageSrc({
  theme,
  layerName,
}: {
  theme?: MapTheme;
  layerName: DropZoneOverlayLayerName;
}): string {
  const selectedTheme = theme ?? DEFAULT_MAP_THEME;
  return dropZoneLayerUrl({ theme: selectedTheme, layerName: `${layerName}.png` });
}

export function resolveDropZoneOverlayImages({
  tiles,
  width,
  x,
  y,
  theme,
}: {
  tiles: readonly Tile[];
  width: number;
  x: number;
  y: number;
  theme?: MapTheme;
}): HTMLImageElement[] {
  return resolveDropZoneOverlayLayerNames({ tiles, width, x, y }).map((layerName) =>
    loadCachedImage(getDropZoneOverlayImageSrc({ theme, layerName })),
  );
}

export function preloadDropZoneImages({ theme }: { theme?: MapTheme }): HTMLImageElement[] {
  const selectedTheme = theme ?? DEFAULT_MAP_THEME;
  return [
    loadCachedImage(dropZoneLayerUrl({ theme: selectedTheme, layerName: "tile.png" })),
    ...DROP_ZONE_OVERLAY_LAYER_NAMES.map((layerName) =>
      loadCachedImage(getDropZoneOverlayImageSrc({ theme: selectedTheme, layerName })),
    ),
  ];
}
